import React from 'react';
import { Alert } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useTranslator } from '@front-activerse/common-components';

const NoConnectionEmptyState: React.FC = () => {
  const { t } = useTranslator();
  return (
    <Alert color="info" data-testid="wearables-dashboard-no-connection">
      <div>{t('wearablesDashboard.noConnection.title')}</div>
      <Link to="/wearables">{t('wearablesDashboard.noConnection.linkLabel')}</Link>
    </Alert>
  );
};

export default NoConnectionEmptyState;
